import { fromJS } from 'immutable';
import { errorlog } from '../helpers/ErrorLogService';
import config from "../config/app.json";

let createRange = (node, chars, range) => {
    if (!range) {
        range = document.createRange()
        range.selectNode(node);
        range.setStart(node, 0);
    }

    if (chars.count === 0) {
        range.setEnd(node, chars.count);
    } else if (node && chars.count >0) {
        if (node.nodeType === Node.TEXT_NODE) {
            if (node.textContent.length < chars.count) {
                chars.count -= node.textContent.length;
            } else {
                 range.setEnd(node, chars.count);
                 chars.count = 0;
            }
        } else {
            for (var lp = 0; lp < node.childNodes.length; lp++) {
                range = createRange(node.childNodes[lp], chars, range);

                if (chars.count === 0) {
                   break;
                }
            }
        }
   } 

   return range;
};

  export const getSVGandColors = (svgEle) => {
    try{
        let tempDiv = document.createElement('div'), colorObj = {}, countObj = {}, count = 1, classTo = '', finalCount =0, colorObjToReturn = {};
        tempDiv.innerHTML = svgEle;
        svgEle = tempDiv.children[0];
        let proceed = true;
        svgEle.childNodes.forEach((ele, idx) => {
            if(ele.getAttribute && ele.getAttribute('fill') && !ele.getAttribute('fill').includes('url') && colorObj.hasOwnProperty(ele.getAttribute('fill'))){
                classTo = colorObj[ele.getAttribute('fill')].class;
                ele.setAttribute('class', classTo);
                countObj[classTo]['count'] += 1;
            }else if(ele.getAttribute && ele.getAttribute('fill') && !ele.getAttribute('fill').includes('url')){
                classTo = `prop${count}`;
                colorObj[ele.getAttribute('fill')] = {idx, class: classTo};
                ele.setAttribute('class', classTo);
                countObj[classTo] = { 'count': 1, color: ele.getAttribute('fill') };
                colorObjToReturn[classTo] = ele.getAttribute('fill');
                finalCount = count;
                count++;
            }else if(ele.getAttribute && ((ele.getAttribute('fill') && ele.getAttribute('fill').includes('url')) || !ele.getAttribute('fill')) ){
                proceed = false;
            }
        })
        
        if(proceed && finalCount && finalCount > 7){
            for(let key in countObj){
                if(countObj[key]['count'] === 1){
                    if(finalCount <= 7){
                        break;
                    }else{
                        svgEle.querySelector(`.${colorObj[countObj[key]['color']].class}`).removeAttribute('class');
                        finalCount -= 1;
                        delete colorObjToReturn[key];
                    }
                }
            }
        }
        if(proceed && finalCount){
            let propCount = 1,
            objIdx = Object.keys(colorObjToReturn);
            for(let i=0; i<objIdx.length; i++){
                if(parseInt(objIdx[i].split('prop')[1]) !== propCount){
                    colorObjToReturn[`prop${propCount}`] = colorObjToReturn[objIdx[i]];
                    delete colorObjToReturn[objIdx[i]];
                    svgEle.querySelectorAll(`.${objIdx[i]}`).forEach(ele => {
                        ele.setAttribute('class', `prop${propCount}`)
                    })
                }
                propCount++;
            }
            return{
                'svgEle' : svgEle,
                'colorObj' : colorObjToReturn
            }
        }

        if(!Object.keys(colorObjToReturn).length){
            let classObj = {}, valArr = [], objToReturn = {}, styleAttr;
            svgEle.querySelectorAll('g').forEach(ele => {
                let eleChild = ele.children;
                for(let key = 0; key < eleChild.length; key++){
                    if(eleChild[key].nodeName !== 'g'){
                        if(eleChild[key].getAttribute('style') && (eleChild[key].getAttribute('style').includes('fill') || eleChild[key].getAttribute('style').includes('stroke'))){
                            let re = /(fill|stroke):([^:]+)(;|;})/g,
                            res = re.exec(eleChild[key].getAttribute('style'));
                            if(!res[2].includes('url')){
                                if(valArr.indexOf(res[2]) === -1){
                                    valArr.push(res[2]);
                                    let classTo = `prop${key+1}`;
                                    if(valArr.length && Object.keys(classObj).length){
                                        classTo = `prop${parseInt(classObj[valArr[valArr.length -1]].split('prop')[1]) + 1}`
                                    }
                                    classObj[res[2]] = classTo;
                                    if(eleChild[key].getAttribute('class')){
                                        eleChild[key].classList.add(classTo);
                                        eleChild[key].setAttribute(res[1], res[2]);
                                    }else{
                                        eleChild[key].setAttribute('class', classTo);
                                        eleChild[key].setAttribute(res[1], res[2]);
                                    }
                                }else{
                                    if(eleChild[key].getAttribute('class')){
                                        eleChild[key].classList.add(classObj[res[2]]);
                                        eleChild[key].setAttribute(res[1], res[2]);
                                    }else{
                                        eleChild[key].setAttribute('class', classObj[res[2]]);
                                        eleChild[key].setAttribute(res[1], res[2]);
                                    } 
                                }
                                if(styleAttr){
                                    styleAttr = styleAttr.replace(`${res[1]}:${res[2]};`, '');
                                }else{
                                    styleAttr = eleChild[key].getAttribute('style').replace(`${res[1]}:${res[2]};`, '');
                                }
                                eleChild[key].setAttribute('style', styleAttr);
                                eleChild[key].getAttribute('style')
                            }else{
                                proceed = false;
                            }
                            
                        }else{
                            if(!svgEle.querySelector('defs > style')){
                                if(!eleChild[key].getAttribute('class') && !eleChild[key].getAttribute('fill')){
                                    eleChild[key].setAttribute('fill', 'black');
                                    eleChild[key].setAttribute('class', 'prop1');
                                    if(!objToReturn['prop1'])
                                        objToReturn['prop1'] = 'black';
                                }else{
                                    proceed = false;
                                }
                            }
                        }
                    }
                }
            });
            if(valArr.length){
                Object.keys(classObj).forEach(val => {
                    objToReturn[classObj[val]] = val;
                })
            }
            if(svgEle.querySelector('defs > style') && !Object.keys(objToReturn).length){
                const styStr = svgEle.querySelector('defs > style').innerHTML,
                regEx = /\s*([^[}]+)(stroke|fill):([^:]+)(;|;})/g;
                let reArr;
                if(styStr){
                    proceed = true;
                    do{
                        reArr = regEx.exec(styStr);
                        if(reArr){
                            let classes = reArr[1].substring(0, reArr[1].length -1);
                            classes = classes.split(',');
                            classes.forEach(cls => {
                                let clsNo = cls.charAt(cls.length -1); 
                                svgEle.querySelectorAll(cls).forEach(ele => {
                                    if(reArr[2] === 'stroke'){
                                        if(!ele.classList.contains(`prop${clsNo}`)){
                                            ele.classList.add(`prop${clsNo}`);
                                        }
                                        if(!ele.classList.contains(`applyStroke`)){
                                            ele.classList.add('applyStroke');
                                        }
                                    }else{
                                        if(!ele.classList.contains(`prop${clsNo}`))
                                            ele.classList.add(`prop${clsNo}`);
                                    }
                                })
                                if(reArr[3] !== 'none') {
                                    classObj[`prop${clsNo}`] = reArr[3];
                                    valArr.push(reArr[3]);
                                }

                            })
                        }
                    }while(reArr);
                }else{
                    proceed = false;
                }
                objToReturn = classObj;
            }else if(!Object.keys(objToReturn).length){
                proceed = false;
            }

            if(!proceed){
                return false;
            }else{
                return{ svgEle, colorObj : objToReturn }
            }
            
        }
        
      
    }catch(err){
      errorlog('Error in getSVGandColors ',err, "utilityMethod-getSVGandColors ");
      return null;
    }
  }
  
  export const canPaste = (pastedData) => {
      try{
        let isInProcess = false;
        if(pastedData.dataType === 'SCENES'){
            for(let idx=0; idx< pastedData.data.length; idx++){
                let wrkspcItems = pastedData.data[idx].workspaceItems,
                wrkspcChildren = pastedData.data[idx].workspaceChildren,
                wrkspcBG = pastedData.data[idx].workspaceBG;

                if(wrkspcItems.length){
                    for(let wii=0; wii<wrkspcItems.length; wii++){
                        if(wrkspcItems[wii].isBlob){
                            isInProcess = true;
                            break;
                        }
                    }
                }
                if(isInProcess){
                    break;
                }

                if(wrkspcChildren.length){
                    for(let wci=0; wci<wrkspcChildren.length; wci++){
                        if(wrkspcChildren[wci].isBlob){
                            isInProcess = true;
                            break;
                        }
                    }
                }

                if(isInProcess){
                    break;
                }

                if(wrkspcBG){
                    if(wrkspcBG.isBlob){
                        isInProcess = true;
                        break;
                    }
                }
            }
        }else{
            let wrkspcItems = pastedData.data.workspaceItems;
            for(let i=0; i<wrkspcItems.length; i++){
                if(wrkspcItems[i].isBlob){
                    isInProcess = true;
                    break;
                }
            }
            let wrkspcChild = pastedData.data.workspaceChildren;
            let wrkCKeys = Object.keys(wrkspcChild);
            if(wrkCKeys.length){
                for(let wck=0; wck<wrkCKeys.length; wck++){
                    if(wrkspcChild[wrkCKeys[wck]].isBlob){
                        isInProcess = true;
                        break;
                    }
                }
            }
        }
        return isInProcess;
      }catch(err){
          errorlog('Error in canPaste ',err, "utilityMethod-canPaste");
      }
  }

  export const sortGroupEle = (preData, isAddAll) => {
      try{
        let revisedData = preData;
        if(!isAddAll){
            let wrkItems = revisedData.get('workspaceItems');
            wrkItems.map((data, key) => {
              let grpChlds = data.get('groupChildren'), allChildren;
              if(grpChlds){
                grpChlds = data.get('groupChildren').toJS();
                allChildren = revisedData.get('workspaceChildren');
                allChildren = allChildren.sortBy((value, key) => {
                  return value.get('index');
                });
                let upList = [];
                allChildren.map( (cData, aKey) => {
                  if(grpChlds.indexOf(aKey) !== -1){
                    upList.push(aKey);
                  }
                })
                revisedData = revisedData.setIn(['workspaceItems', key, 'groupChildren'], fromJS(upList));
              }
            })
        }else{
            let sceneData = revisedData.getIn(["project", "scenes"]);
            sceneData.entrySeq().forEach(([sceneNum, sceneVal]) => {
                let wrkItems = sceneVal.get('workspaceItems');
                wrkItems.map((data, key) => {
                    let grpChlds = data.get('groupChildren'), allChildren;
                    if(grpChlds){
                        grpChlds = data.get('groupChildren').toJS();
                        allChildren = sceneVal.get('workspaceChildren');
                        allChildren = allChildren.sortBy((value, key) => {
                            return value.get('index');
                        });
                        let upList = [];
                        allChildren.map( (cData, aKey) => {
                            if(grpChlds.indexOf(aKey) !== -1){
                            upList.push(aKey);
                            }
                        })
                        revisedData = revisedData.setIn(['project', 'scenes', sceneNum, 'workspaceItems', key, 'groupChildren'], fromJS(upList));
                    }
                })
            })
        }
        return revisedData;
      }catch(err){
          errorlog('Error in sortGroupEle ', err, "utilityMethod-sortGroupEle");
      }
  }

  export const arraysEqual=(a, b)=> {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  export const removeSelection = () => {
    try {
        if (window.getSelection) {
            if (window.getSelection().empty) {  // Chrome
                window.getSelection().empty();
            } else if (window.getSelection().removeAllRanges) {  // Firefox
                window.getSelection().removeAllRanges();
            }
        } else if (document.selection) {  // IE?
            document.selection.empty();
        }
    } catch (er) {
        errorlog("Error in removeSelection ", er, "utilityMethod");

    }
}

export const preloadTextFonts = (htmlText) => {
    const assetUrl = config['ASSETS'][config['ASSETS']['current']];
    const userFontUrl = config.UPLOADS["font_src"];
    const textElement = document.createElement('div');
    textElement.innerHTML = htmlText;
    let partialFontArr = [];

    textElement.querySelectorAll(`[data-ff]`).forEach(node => {
        let url = "";
        if (node.getAttribute("data-uf") === "true" && node.getAttribute("data-src")) {
            url = node.getAttribute("data-src").includes(userFontUrl) ? node.getAttribute('data-src') : `${userFontUrl}${node.getAttribute('data-src')}`;
        } else if (node.getAttribute("data-uf") !== "true") {
            url = `${assetUrl}animaker/admin-fonts/${node.getAttribute('data-ff')}.css`;
        }

        if (url.length > 0) {
            partialFontArr.push({
                font: node.getAttribute("data-ff"),
                load: node.style.fontFamily,
                byUser: node.getAttribute("data-uf"),
                isLoaded: false,
                url,
                isPartialFont: true
            });
        }
    });

    textElement.querySelectorAll(`font`).forEach(node => {
        let url = "";
        if (node.getAttribute("data-uf") === "true" && node.getAttribute("data-src") && node.getAttribute('face')) {
            url = node.getAttribute("data-src").includes(userFontUrl) ? node.getAttribute('data-src') : `${userFontUrl}${node.getAttribute('data-src')}`;
        } else if (node.getAttribute("data-uf") !== "true" && node.getAttribute('face')) {
            url = `${assetUrl}animaker/admin-fonts/${node.getAttribute('face').split('-')[0]}.css`;
        }
        if (url.length > 0) {
            partialFontArr.push({
                font: node.getAttribute('face').split('-')[0],
                load: node.getAttribute('face'),
                byUser: false,
                isLoaded: false,
                url,
                isPartialFont: true
            });
        }
    });
    return partialFontArr;
}


// WEBPACK FOOTER //
// ./src/helpers/utilityMethods.js